import React from "react";
import {cs} from "@common/react/chain-services";
import {TextManipulationResultActionSelect} from "../../common/text-manipulation-result-action-select";
import {rColumnValueSelectFromStepOutput} from "../../../../../common/column-value-select-from-step-output/column-value-select-from-step-output";
import {ffToDropdown} from "../../../../../../../../../../common/form/ff-to-dropdown";
import {keepOnly} from "@common/utils/objects";
import {ffToTextInput} from "../../../../../../../../../../common/form/ff-to-text-input";
import {DebounceTextInput} from "../../../../../../../../../../common/form/debounce-input/debounce-text-input";
import {rNewColumnNameInput} from "../../../common/new-column-name-input";

export const JsonValueConfiguration = ({textManipulation, inputStep, state, model, form}) =>
    cs(() => {
        return (
            <>
                <div className="config-group">
                    <div className="label">Input JSON Column</div>

                    {(() => {
                        const dropdownProps = ffToDropdown(form.field(["textManipulation", "inputValue"]));
                        return rColumnValueSelectFromStepOutput({
                            label: "Column",
                            columns: inputStep.outputColumns,
                            model,
                            disableStaticValue: true,
                            filterColumnFn: (c) => ["Text"].includes(c.dataType),
                            isValueNotAllowed: (c) => !["Text"].includes(c.dataType),
                        })({
                            state: {
                                value: dropdownProps.value,
                                onChange: dropdownProps.onChange,
                            },
                            ...keepOnly(dropdownProps, ["domRef", "hasError", "errorMessage"]),
                        });
                    })()}
                </div>

                <div className="config-group">
                    <div className="label">JSON Path</div>

                    <div className="flex-group">
                        {(() => {
                            const inputProps = ffToTextInput(form.field(["textManipulation", "path"]));
                            return DebounceTextInput({
                                label: "Dot Notation Path",
                                ...inputProps,
                                state: {
                                    value: inputProps.state.value,
                                    onChange: (v) => inputProps.state.onChange(v),
                                },
                            });
                        })()}
                    </div>
                </div>

                <div className="config-group">
                    <div className="label">New Column Name</div>

                    {rNewColumnNameInput({
                        form,
                        newColumnPath: ["textManipulation", "newColumn"],
                        newColumnNamePath: ["textManipulation", "newColumn", "name"],
                    })}
                </div>
            </>
        );
    });
